module.exports = __webpack_public_path__ + "img/cfc9b205ab064f1892ebf9459d8b774c.png";


//////////////////
// WEBPACK FOOTER
// ./common/assets/images/texture.png
// module id = 24
// module chunks = 0